import shortid from "shortid";
import { AddressBookTab } from '../../../constants/ComponentTypes';

const makeAddress = (item) => {
  let tags = [];

  if (item && item && item.tags) {
    if (typeof item.tags === 'string') {
      tags = item.tags.split(',').map(tag => tag.trim());
    } else if (Array.isArray(item.tags)) {
      tags = [...item.tags];
    }
  }

  const jpCountryId = 392;
  let res = {
    country_id: (item.country_id ? item.country_id : jpCountryId),
    id: (item.id ? item.id : shortid.generate()),
    status: (item.status ? item.status : AddressBookTab.SILENT),
    post_code: (item.post_code ? item.post_code : ""),
    company: (item.company ? item.company : ""),
    branch: (item.branch ? item.branch : ""),
    position: (item.position ? item.position : ""),
    name: (item.name ? item.name : ""),
    honorific: (item.honorific ? item.honorific : ""),
    address: (item.address ? item.address : ""),
    tel: (item.tel ? item.tel : ""),
    fax: (item.fax ? item.fax : ""),
    email: (item.email ? item.email : ""),
    tags: tags,
    detail: (item.detail ? item.detail : {}),
  };

  if (item && item.corporate_number) {
    res['corporate_number'] = item.corporate_number;
  }

  if (item && item.corporation) {
    res['corporation'] = item.corporation;
  }

  if (item.link_corporation_status !== null && item.link_corporation_status !== undefined) {
    res['link_corporation_status'] = item.link_corporation_status;
  }

  return res;
};

const makeNgItem = (item) => {
  let corporate_number = '';

  if (item.hasOwnProperty('corporate_number')) {
    corporate_number = item.corporate_number;
  } else if (item && item.corporation && item.corporation.corporate_number) {
    corporate_number = item.corporation.corporate_number;
  }

  let res = {
    corporate_number: corporate_number,
    name: item.name ? item.name : '',
  };

  if (item.hasOwnProperty('id')) {
    res['id'] = item.id;
  }

  return res;
}

const AddressBookUtil = {
  makeAddress,
  makeNgItem,
}

export default AddressBookUtil;



// WEBPACK FOOTER //
// ./src/components/AddressBook/utils/AddressBookUtil.js